import { Button, Flex, Form, Modal, Select } from 'antd'
import { ModalProps, SelectProps } from 'antd/lib'
import { useTheme } from 'antd-style'

import { requiredRules } from 'src/app-constants'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

const options: SelectProps['options'] = []

for (let i = 10; i < 36; i++) {
  options.push({
    label: i.toString(36) + i,
    value: i.toString(36) + i
  })
}

type Props = {
  onCancel: () => void
} & ModalProps

export const EditReportModal = ({ onCancel, ...props }: Props) => {
  const { t } = useLocales()
  const palette = useTheme()
  const [form] = Form.useForm()

  const onSubmit = async () => {
    await form.validateFields()
    onCancel()
  }

  return (
    <Modal
      open
      maskClosable={false}
      title={
        <Text size="xxl" weight={600}>
          {t('reports_administration.assignee_role')}
        </Text>
      }
      footer={
        <Flex justify="center" gap={16}>
          <Button onClick={onCancel}>{t('common.cancel')}</Button>
          <Button type="primary" onClick={onSubmit}>
            {t('common.save')}
          </Button>
        </Flex>
      }
      onCancel={onCancel}
      {...props}
    >
      <Flex vertical gap={24}>
        <Flex vertical gap={8}>
          <Text color={palette.colorTextDescription}>
            {t('reports.report_title')}
          </Text>

          <Text size="xl" weight={600}>
            Raport Anual de Activitate Clinică și Administrativă
          </Text>
        </Flex>

        <Flex vertical gap={8}>
          <Text color={palette.colorTextDescription}>{t('menu.roles')}</Text>

          <Form form={form} layout="vertical" requiredMark={false}>
            <Form.Item name="roles" rules={requiredRules}>
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                options={options}
              />
            </Form.Item>
          </Form>
        </Flex>
      </Flex>
    </Modal>
  )
}
